import { IncomingMessage } from 'http';

import { DIGITAL_JOURNAL_PATH_PREFIX } from '@/utils/sensitivePaths';

export const getUserToken = (
	cookies: Record<string, string>,
	req: IncomingMessage,
	calmUserToken?: string,
) => {
	if (cookies['calm-user-token']) {
		return cookies['calm-user-token'];
	}

	if (calmUserToken) {
		return calmUserToken;
	}

	if (req.url) {
		const parsedUrl = new URL(req.url, `https://${req.headers.host}`);
		// On journal pages `token` is a download-resend credential, not a session, and must not be
		// sent to the API as x-session-token.
		if (parsedUrl.pathname.includes(DIGITAL_JOURNAL_PATH_PREFIX)) {
			return undefined;
		}
		return parsedUrl.searchParams.get('token');
	}
};
